<section class="rs-content-wrapper rs-header-has-level2">
  <mprd-flex-emergency-manage-skeleton-pxsplus
    *ngIf="isPending"
  ></mprd-flex-emergency-manage-skeleton-pxsplus>
  <main id="maincontent" role="main" *ngIf="!isPending">
    <div class="rs-fe3"></div>
    <div class="row">
      <div class="columns small-12">
        <a
          href="javascript:void(0)"
          class="rs-btn rs-btn-third rs-btn-third-icon-left"
          (click)="routeToStep1()"
          ><i class="rs-icon-btn-third rs-margin-right1" aria-hidden="true"></i>
          {{ 'flexEmergency.common.back' | translate }}
        </a>

        <div class="rs-me"></div>
        <h1 class="rs-tit4">{{ 'flexEmergency.manage.title' | translate }}</h1>
        <ng-container *ngIf="!isOnlyOneNumber">
          <p class="rs-txt-s5">{{ 'flexEmergency.manage.selectMobile' | translate }}</p>
        </ng-container>
        <div class="rs-flex-row">
          <div
            *ngFor="let product of eligibleFlexEmergencyProducts"
            class="rs-flex-columns small-12 medium-6"
          >
            <mprd-flex-product-card
              [product]="product"
              [oneAlreadyActive]="oneAlreadyActive"
              (checkForOneActive)="checkForOneActive()"
            ></mprd-flex-product-card>
          </div>
        </div>
        <div class="rs-me"></div>
        <h2 class="rs-tit5">F.A.Q.</h2>
        <p
          [innerHTML]="'flexEmergency.manage.faqContent' | translate: true"
          data-tms-event="button-click"
          data-tms-button-zone="flex-emergency-manage"
          data-tms-button-name="ENG value of the button"
        ></p>
      </div>
    </div>
    <div class="rs-le2"></div>
  </main>
</section>
